
const sh = require('shelljs')
const { primary } = require('../common.js')

function sync(yargs) {

	console.log(primary('ops sync --'))

	const message = yargs.argv._.slice(1, yargs.argv._.length).join(' ')
	sh.exec('git add -A', { silent: true })
	console.log(`\t"${message}"`)

	// Commit if there are uncommitted files

	const untracked = sh.exec(
		'git ls-files --others --exclude-standard',
		{ silent: true }
	).stdout

	const unstaged = sh.exec(
		'git diff-files --ignore-submodules --',
		{ silent: true }
	).stdout

	const uncommitted = sh.exec(
		'git diff --ignore-submodules --cached',
		{ silent: true }
	).stdout

	if (untracked || unstaged || uncommitted)
		sh.exec(`git commit -m "${message || "sync"}"`, { silent: true })

	// Find the name of the current branch

	const branch = sh.exec(
		'git symbolic-ref --quiet --short HEAD',
		{ silent: true }
	).stdout.trim()

	// Pull
	const pullResult = sh.exec(`git pull origin ${branch}`, { silent: true })
	console.log('pullResult', pullResult.stdout)

	// Deal with conflicts, list files with conflicts,
	// offer option to open in text editor
	// if yes automatically do the following:
	// offer to wait until conflicts are fixed
	// offer "conflicts fixed" and "cancel" buttons

	// Push
	sh.exec(`git push origin ${branch}`, { silent: true })

	console.log(primary('sync complete ✓'))


}

module.exports = sync



// WEBPACK FOOTER //
// ./src/commands/sync.js